// extracted by mini-css-extract-plugin
export default {"cardContainer":"SearchItemCard_cardContainer__Wgu5A","name":"SearchItemCard_name__cwT+i","email":"SearchItemCard_email__sEoii","department":"SearchItemCard_department__X3-Ra"};